module.exports = function (data) {
   const products = [];
   let productRemoved;
   if (data.productsRemoved) {
      for (let i = 0; i < data.productsRemoved.length; i++) {
         productRemoved = data.productsRemoved[i];
         products.push({
             quantity: productRemoved.Quantity,
             unitPrice: productRemoved.SalePrice || productRemoved.UnitPrice,
             unitDisplay: productRemoved.Unit,
             productInfo: productRemoved.ProductData,
             isOnSpecial: productRemoved.IsSpecial ? 'true' : 'false'
          });
      }
   }

   return {
       event: 'BWSAUEmptyCart',
       eventContext: {
           area: data.area,
           products
       }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/atmmapper/clear-trolley-mapper.js
 **/